module.exports = __webpack_public_path__ + "static/media/400022_01.52675349.png";